<template>
    <div class="select-wrap"
         @mouseleave="hover = false"
         @mouseover="hover = true">
        <div @click="toggleList()" class="select align-center justify-between">
            {{label}}
            <svg width="10px" height="5px" :class="['drop-icon', {'rotate': showList}]" fill="var(--lighten-5-color)">
                <use xlink:href="../../assets/images/sprite.svg#drop-angle"></use>
            </svg>
        </div>
        <div class="drop-down-list" v-show="showList">
            <div v-for="(item, key) in list"
                 :key="key"
                 class="drop-down-group mb-6">
                <div v-for="(item2, key2) in item"
                     :key="key2"
                     class="mb-2">
                    <h4 class="mb-2">{{item2.label}}</h4>
                    <div v-for="(item3, key3) in item2.items"
                         :key="key3"
                         :class="['drop-down-item align-center justify-between']">
                        <radio-btn v-if="!item3.IsDeleted"
                                   :value="checkIsChecked(key, key2, key3)"
                                   @change="change(key, key2, key3)">
                            {{correctDate(item3.Details[0].Date)}} ({{correctPrice(item3.Details[0].Cost) +' '+ getCurrencyDisplayBySettings(rate)}})
                        </radio-btn>
                        <checkbox v-else
                                  :value="checkIsChecked(key, key2, key3)"
                                  :label="getLabel(item3, item2)"
                                  @change="change(key, key2, key3)">
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "hotelSelect",
        data() {
            return {
                showList: false,
                hover: false,
                select: null,
                list: [],
                selectedIndex: []
            }
        },
        props: {
            items: {
                type: Array,
                required: true
            },
            value: {
                type: Array,
                default: () => []
            },
            rate: {
                type: String,
                default: ""
            },
        },
        computed: {
            label() {
                let res = "";
                this.list.forEach(x => {
                    x.forEach(x2 => {
                        if (x2.selected !== null) {
                            res += (res.length ? ", " : "") + x2.label
                        }
                    })
                });

                if (!res) res = this.localizeList?.notRequiredUpper || '';
                return res;
            },
            selected() {
                let res = [];
                this.list.forEach(x => {
                    x.forEach((x2, i2) => {
                        if (x2.selected !== null) {
                            x2.items[x2.selected].index = i2;
                            res.push(x2.items[x2.selected])
                        }
                    })
                });
                return res
            }
        },
        mounted() {
            this.setList()
        },
        methods: {
            setList() {
                this.list = this.items.map((x) => {
                    let group = [];

                    x.forEach((x2) => {
                        let selected = null;
                        let selectedIndex = this.list[0]?.map(x3 => x3.code).indexOf(x2.Code.Key);
                        if (selectedIndex !== -1 && selectedIndex !== undefined) {
                            selected = this.list[0][selectedIndex].selected
                        }

                        let index = group.map(x3 => x3.code).indexOf(x2.Code.Key);
                        if (index !== -1) {
                            group[index].items.push(x2)
                        } else {
                            group.push({
                                label: x2.Code.Value,
                                code: x2.Code.Key,
                                selected: (selected || selected === 0) ? selected : (x2.IsDeleted ? null : 0),
                                items: [x2]
                            })
                        }
                    });

                    return group
                });
            },
            checkIsChecked(key1, key2, key3) {
                const selected = this.list[key1][key2].selected;
                return key3 === selected
            },
            change(key1, key2, key3) {
                const isDeleted = this.list[key1][key2].items[key3].IsDeleted;
                const selected = this.list[key1][key2].selected;

                if (isDeleted) {
                    this.list[key1][key2].selected = selected === key3 ? null : key3;
                } else {
                    this.list[key1][key2].selected = key3
                }
            },
            outside() {
                if (!this.hover) {
                    this.hideList();
                }
            },
            toggleList() {
                if (!this.disabled) {
                    this.showList = !this.showList;
                }
            },
            hideList() {
                this.showList = false;
            },
            correctDate(date) {
                if (!date) return "";
                return date.split("T")[0].split("-").reverse().join(".")
            },
            getCurrencyDisplayBySettings(code){
                if (!code) return "";

                let allRate = this.$store.getters['getCurrency'];
                let rate = allRate.find(x => x.Code === code);

                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            getLabel(item, parent) {
                const date = this.correctDate(item.Details[0].Date);
                return (date ? date + ' ' : '') + '(' +
                        ((parent.selected === null ? this.getPlus(item.Details[0].Cost) : '') +
                        this.correctPrice(item.Details[0].Cost) +' '+
                        this.getCurrencyDisplayBySettings(this.rate)) + ')'
            },
            getPlus(numb) {
                return numb <= 0 ? "" : "+"
            },
            correctPrice(val) {
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
        },
        watch: {
            items: {
                deep: true,
                handler() {
                    this.setList()
                }
            },
            selected: {
                deep: true,
                handler(val) {
                    this.$emit("change", [...val])
                }
            },
            showList(val) {
                if (val) {
                    window.addEventListener("click", this.outside);
                } else {
                    window.removeEventListener("click", this.outside);
                }
            }
        }
    }
</script>

<style scoped>
    .select-wrap {
        position: relative;
        width: 100%;
    }
    .select-wrap .second-label {
        color: var(--primary-color);
    }

    .select-wrap .select {
        position: relative;
        width: 100%;
        border: none;
        outline: none;
        padding: 8px 26px 8px 12px;
        background-color: var(--white-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
        cursor: pointer;
    }

    .select-wrap .select .drop-icon{
        position: absolute;
        top: calc(50% - 2px);
        right: 11px;
        transition: all .2s;
    }

    .select-wrap .select .drop-icon.rotate{
        transform: rotate(180deg)
    }

    .select-wrap .drop-down-list {
        width: 100%;
        max-height: 300px;
        overflow: auto;
        position: absolute;
        top: 100%;
        left: 0;
        border-radius: 4px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        padding: 6px 10px;
        background-color: var(--white-color);
        margin-bottom: 20px;
        z-index: 10;
    }

    .select-wrap .drop-down-list .drop-down-item {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--dark-1-color);
        padding: 4px 12px;
    }
    .select-wrap .drop-down-list .drop-down-item /deep/.c-checkbox #c-checkbox {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--dark-1-color);
    }
</style>
